import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initSuiteAppearance } from "@fg/ui-theme";
import { App } from "./App";
import { oidcConfig } from "@/auth/authConfig";
import { I18nProvider } from "@/i18n";

import "./styles/globals.css";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false
        }
    }
});

// Suite look (mode, accent, top bar) — Connect's own look if it has one.
initSuiteAppearance("connect");

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found in index.html");

ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
        <I18nProvider>
            <AuthProvider {...oidcConfig}>
                <QueryClientProvider client={queryClient}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </QueryClientProvider>
            </AuthProvider>
        </I18nProvider>
    </React.StrictMode>
);
